"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = require("i18next");
var react_1 = __importStar(require("react"));
var inertia_1 = require("@inertiajs/inertia");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var logger = q_play_core_1.logManager.getLogger();
var route = (0, useRoute_1.default)();
var AppErrorBoundary = /** @class */ (function (_super) {
    __extends(AppErrorBoundary, _super);
    function AppErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    AppErrorBoundary.getDerivedStateFromError = function () {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    };
    AppErrorBoundary.prototype.componentDidCatch = function (error, info) {
        var errorToLog = error;
        errorToLog.stack = info.componentStack;
        logger.error(errorToLog.message, errorToLog);
    };
    AppErrorBoundary.prototype.triggerClearSessionAndRedirect = function () {
        inertia_1.Inertia.post(route("logout"));
        location.href = route("login");
    };
    AppErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return (react_1.default.createElement("div", { style: { width: "100%", height: "100vh" }, className: "d-flex justify-content-center align-items-center" },
                react_1.default.createElement("div", { style: { width: "350px", height: "285px", zIndex: 1, border: "solid 1px lightblue", borderRadius: "12px", background: "rgb(154, 199, 230)", padding: "20px" } },
                    react_1.default.createElement("h3", { style: { textAlign: "center" } }, (0, i18next_1.t)("An error occurred")),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center" },
                        react_1.default.createElement("span", { style: { textAlign: "center", fontSize: "1.1em" } }, (0, i18next_1.t)("You must sign in again")),
                        react_1.default.createElement(q_play_components_1.Button, { className: "p-1", text: (0, i18next_1.t)("Sign in again"), variant: "primary", size: "small", onClick: this.triggerClearSessionAndRedirect })),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center" },
                        react_1.default.createElement("span", { style: { textAlign: "center", fontSize: "1.1em" } }, (0, i18next_1.t)("If the error remains please contact support: +45 71 92 62 22 or support@nordicscreen.com"))))));
        }
        return this.props.children;
    };
    return AppErrorBoundary;
}(react_1.Component));
exports.default = AppErrorBoundary;
